import { UserSettings } from 'feature/user/view'
import { FitterSettings } from 'feature/user/view/FitterSettings/FitterSettings'
import { MainLayout } from 'layouts'
import { isLkmDomain } from 'router/utils'

export function UserSettingsPage() {
  const isLkm = isLkmDomain()

  return (
    <MainLayout>
      <div className='container'>
        {isLkm ? <FitterSettings /> : <UserSettings />}
      </div>
    </MainLayout>
  )
}
